function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */


import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import classNames from 'classnames';
import { EuiNotificationBadge } from '../../badge/notification_badge/badge_notification';
import { EuiIcon } from '../../icon';
import { EuiButtonEmpty } from '../../button';
import { EuiHideFor, EuiShowFor } from '../../responsive';
export var EuiHeaderSectionItemButton = /*#__PURE__*/forwardRef(function (_ref,
/**
 * Allows for animating with .euiAnimate()
 */
ref) {
  var children = _ref.children,
      className = _ref.className,
      notification = _ref.notification,
      _ref$notificationColo = _ref.notificationColor,
      notificationColor = _ref$notificationColo === void 0 ? 'accent' : _ref$notificationColo,
      rest = _objectWithoutProperties(_ref, ["children", "className", "notification", "notificationColor"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      buttonRef = _useState2[0],
      setButtonRef = _useState2[1];

  var animationTargetRef = useRef(null);
  useImperativeHandle(ref, function () {
    if (buttonRef) {
      buttonRef.euiAnimate = function () {
        var _animationTargetRef$c;

        var keyframes = [{
          transform: 'rotate(0)',
          offset: 0,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(30deg)',
          offset: 0.01,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-28deg)',
          offset: 0.03,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(34deg)',
          offset: 0.05,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-32deg)',
          offset: 0.07,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(30deg)',
          offset: 0.09,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-28deg)',
          offset: 0.11,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(26deg)',
          offset: 0.13,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-24deg)',
          offset: 0.15,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(22deg)',
          offset: 0.17,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-20deg)',
          offset: 0.19,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(18deg)',
          offset: 0.21,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-16deg)',
          offset: 0.23,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(14deg)',
          offset: 0.25,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-12deg)',
          offset: 0.27,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(10deg)',
          offset: 0.29,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-8deg)',
          offset: 0.31,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(6deg)',
          offset: 0.33,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-4deg)',
          offset: 0.35,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(2deg)',
          offset: 0.37,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(-1deg)',
          offset: 0.39,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(1deg)',
          offset: 0.41,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(0)',
          offset: 0.43,
          easing: 'ease-in-out'
        }, {
          transform: 'rotate(0)',
          offset: 1,
          easing: 'ease-in-out'
        }];
        (_animationTargetRef$c = animationTargetRef.current) === null || _animationTargetRef$c === void 0 ? void 0 : _animationTargetRef$c.animate(keyframes, {
          duration: 5000
        });
      };

      return buttonRef;
    } else {
      return null;
    }
  }, [buttonRef]);
  var classes = classNames('euiHeaderSectionItemButton', className);
  var animationClasses = classNames(['euiHeaderSectionItemButton__content']);
  var notificationDot = /*#__PURE__*/React.createElement(EuiIcon, {
    className: "euiHeaderSectionItemButton__notification euiHeaderSectionItemButton__notification--dot",
    color: notificationColor,
    type: "dot",
    size: "l"
  });
  var buttonNotification;

  if (notification === true) {
    buttonNotification = notificationDot;
  } else if (notification) {
    buttonNotification = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EuiHideFor, {
      sizes: ['xs']
    }, /*#__PURE__*/React.createElement(EuiNotificationBadge, {
      className: "euiHeaderSectionItemButton__notification euiHeaderSectionItemButton__notification--badge",
      color: notificationColor
    }, notification)), /*#__PURE__*/React.createElement(EuiShowFor, {
      sizes: ['xs']
    }, notificationDot));
  }

  return /*#__PURE__*/React.createElement(EuiButtonEmpty, _extends({
    className: classes,
    color: "text",
    buttonRef: setButtonRef
  }, rest), /*#__PURE__*/React.createElement("span", {
    ref: animationTargetRef,
    className: animationClasses
  }, children), buttonNotification);
});
EuiHeaderSectionItemButton.displayName = 'EuiHeaderSectionItemButton';